<template>
  <q-list bordered separator class="bg-white rounded-borders">
    <q-item
      v-for="(batter, i) in lineup"
      :key="'slot-' + batter.battingOrder"
      clickable
      @click="editBatter(batter)"
    >
      <q-item-section avatar class="text-weight-bold text-primary">
        {{ batter.battingOrder }}.
      </q-item-section>

      <q-item-section>
        <q-item-label class="text-weight-bold">{{ batter.player.name }}</q-item-label>
        <q-item-label caption>
          #{{ batter.player.uniformNumber }} | Position: {{ batter.startingPosition }}
        </q-item-label>

        <div v-if="batter.substitutions && batter.substitutions.length > 0" class="q-mt-xs">
          <q-item-label
            v-for="(sub, subIdx) in batter.substitutions"
            :key="'sub-' + sub.player.id + '-' + subIdx"
            caption
            class="text-grey-6 text-italic flex items-center"
          >
            <q-icon name="swap_horiz" size="xs" class="q-mr-xs" />
            Subbed out: {{ sub.player.name }} (#{{ sub.player.uniformNumber }})
          </q-item-label>
        </div>
      </q-item-section>

      <q-item-section side>
        <div class="row">
          <q-btn
            flat
            dense
            round
            icon="arrow_upward"
            @click.stop="gameStore.moveBatter(role, i, 'up')"
            :disable="i === 0"
          />
          <q-btn
            flat
            dense
            round
            icon="arrow_downward"
            @click.stop="gameStore.moveBatter(role, i, 'down')"
            :disable="i === lineup.length - 1"
          />
          <q-btn
            flat
            dense
            round
            icon="delete"
            color="negative"
            @click.stop="gameStore.removeBatterFromLineup(role, i)"
          />
        </div>
      </q-item-section>
    </q-item>

    <q-item v-if="lineup.length === 0">
      <q-item-section class="text-grey text-center q-py-md">
        No players in lineup. Add them now!
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useGameStore } from 'src/stores/game-store'
import type { LineupEntry } from 'src/stores/base-types'

const props = defineProps<{
  modelValue: boolean
  role: 'home' | 'visiting'
}>()

const gameStore = useGameStore()
const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

// Grab the correct array from the store based on the prop
const lineup = computed(() => {
  return props.role === 'home' ? gameStore.homeLineup || [] : gameStore.visitingLineup || []
})

// Trigger the Pinia action to populate the LineupEntryEdit.vue form
const editBatter = (batter: LineupEntry) => {
  gameStore.setEditingBatter(batter)
  emit('update:modelValue', true)
}
</script>
